module.exports = __webpack_public_path__ + "f802223b58ee6326d6991aed52136b61.MP3";